import script from "./LoadingWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingWrapper.vue?vue&type=style&index=0&id=075fffb7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075fffb7"]])

export default __exports__